import * as React from 'react';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { Checkbox, DetailsList, DetailsListLayoutMode, IColumn, SelectionMode, Spinner, SpinnerSize, Stack } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import Project from '../../system/projects/Project';
import { ProjectDocumentControl } from '../../system/projects/ProjectsSystem';
import { MessageBar, MessageBarType } from '@fluentui/react';
import TimeTaxSupportSystemClient from '../../system';
import MessageCourier from '../../lib/MessageCourier';
import { ProjectRelatedDocument } from '../../system/documents/ProjectRelatedDocument';
interface AssignDocumentForDocumentControlRequerimentProps {
  onCloseModal: () => void;
  project: Project;
  projectDocumentControls: ProjectDocumentControl[];
  loadingProjectDocumentControls: boolean;
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  document: ProjectRelatedDocument;
  refresh: () => void;
}

export default function AssignDocumentForDocumentControlRequeriment({ courier, document, project, loadingProjectDocumentControls, projectDocumentControls, system, onCloseModal, refresh }: AssignDocumentForDocumentControlRequerimentProps) {
  const { t } = useTranslation();

  const [selectedId, setSelectedId] = React.useState<string | null>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const handleAssign = async () => {
    if (!selectedId) {
      setError(t('Debes seleccionar un documento antes de asignar.'));
      return;
    }

    try {
      setLoading(true);
      const selectedItem = projectDocumentControls.find((d) => d.ccdp_id === selectedId);
      if (selectedItem) {
        setError(null);
        await system.getProjectSystem().assignDocumentForDocumentControlRequeriment({
          codeProject: project.getCode(),
          controlUploadDocumentId: selectedItem.ccdp_id,
          documentId: document.getId(),
        });
        refresh();
        courier.messageSuccess(t('Documento asigado correctamente'));
      }
    } catch (error) {
      console.log(error);
      courier.messageError(t('No se puedo asignar el documento'));
    } finally {
      onCloseModal();
      setLoading(false);
    }
  };

  const columns: IColumn[] = [
    {
      key: 'concept',
      name: t('Concepto'),
      fieldName: 'ccdp_concepto',
      minWidth: 150,
      maxWidth: 150,
    },
    {
      key: 'documentType',
      name: t('Tipo'),
      fieldName: 'doct_nombre',
      minWidth: 180,
      maxWidth: 180,
      onRender: (item: ProjectDocumentControl) => {
        return item.documentoTipo?.doct_nombre ?? '';
      },
    },
    {
      key: 'limitDate',
      name: t('Fecha Límite'),
      fieldName: 'ccdp_fecha_limite',
      minWidth: 100,
      maxWidth: 100,
    },
    {
      key: 'document',
      name: t('Seleccionar'),
      fieldName: 'doc_nombre',
      minWidth: 100,
      maxWidth: 100,
      onRender: (item: ProjectDocumentControl) => {
        return (
          <Checkbox
            checked={selectedId === item.ccdp_id}
            onChange={() => setSelectedId(item.ccdp_id)}
            styles={{
              root: { justifyContent: 'center' },
            }}
            disabled={loading}
          />
        );
      },
    },
  ];

  if (loadingProjectDocumentControls) {
    return <Spinner size={SpinnerSize.large} styles={{ root: { marginTop: 30 } }} />;
  }

  if (!projectDocumentControls.length) return null;

  return (
    <div>
      <DetailsList items={projectDocumentControls} columns={columns} selectionMode={SelectionMode.none} getKey={(item: ProjectDocumentControl) => item.ccdp_id} layoutMode={DetailsListLayoutMode.fixedColumns} />

      {error && (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false} styles={{ root: { marginTop: 12 } }}>
          {error}
        </MessageBar>
      )}

      <Stack horizontalAlign="end">
        <PrimaryButton onClick={handleAssign} styles={{ root: { marginTop: 12 } }} disabled={loading}>
          {loading && <Spinner size={SpinnerSize.xSmall} styles={{ root: { marginRight: 6 } }} />}
          {t('Asignar')}
        </PrimaryButton>
      </Stack>
    </div>
  );
}
